import { requestGet } from '@/common/request';
import { useEffect, useMemo, useState } from 'react';
import { message } from 'antd';

export interface listHistoryParams {
  type: number;
}

export interface listHistoryRes {
  ret: string;
  msg: string;
  data: { list: Array<{ channelId: string; pic: string; name: string; channelLevel: number }> | [] };
}

//频道最近访问列表
export async function listHistory(params: listHistoryParams): Promise<listHistoryRes> {
  return await requestGet('/channelActivity/listHistory', params);
}

export function useGetListHistory(query: listHistoryParams) {
  const [loading, setLoading] = useState(true);
  const [state, setState] = useState<any>();

  useEffect(() => {
    let didMount = true;
    listHistory({ type: query.type })
      .then((res) => {
        if (!didMount) return;

        const { ret, msg } = res || {};
        if (ret !== '0') {
          message.error(msg || '网络异常请稍候~');
          setLoading(false);
          return;
        } else {
          setState(res?.data);
          setLoading(false);
        }
      })
      .catch((ex) => {
        setLoading(false);
        console.error(ex);
      });

    return () => {
      didMount = false;
    };
  }, [query.type]);

  const data = useMemo(() => {
    return { loading, data: state };
  }, [loading, state]);

  return [data];
}
